import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { popupOpenClose, setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoader, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import MiniLoader from "../../UI/MiniLoader";
import { scrollToTop } from "../../../JS/scrollToTop";
import Gha_WelcomePage from "./Gha_WelcomePage";
import Gha_NewJoin from "./Gha_NewJoin";
import Gha_Login from "./Gha_Login";
import { getGhaPasswordReset, getPasswordReset } from "../../../action/gha";






const Gha_ResetPassword = (props) => {

    const [username,setUsername]=useState("")
    const [currentPage,setCurrentPage]=useState(1);
    const [showLoader, setShowLoader] = useState(false);
    const [ifSuccessfullReset, setIfSuccessfullReset]=useState(false)

  
    let widgetSesstionId = localStorage.getItem("ghaSessionToken");
    let label = getDefaultAnalyticsLabel({
        appVersion: props.installedAppVersion
            ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
            : "",
    });

    const sendAnalytic = (isSuccess, res) => {
        props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            `Login response ${isSuccess ? 'Success' : "failed"}`,
            {
                ...label,
                layoutTab: props.currentHomePage.tabName,
                element: "widget",
                widgetSessionId: widgetSesstionId,
                errorStatus: JSON.stringify(res),
                errorMessage: JSON.stringify(
                    res
                ),
            },
            0,
            props.guestIsLoggedIn
        );
    }


    const { t } = props;

    const resetMyPassword=()=>{
            
        setShowLoader(true);

        getGhaPasswordReset({ username})
        .then((res)=>{
            console.log(res)
            if (res.status == 200 && res.data && res.data.statusMsg=="success"){
                setCurrentPage(2);

            }
            else{throw new Error()}
        })
        .catch(()=>{
            sendAnalytic(false)
            props.closeOrderPopUp(true,  t('gha.errors.reset_my_password'), "", true)
            //send analy
        })
        .finally(()=>{
            setShowLoader(false);
        })
    }

    const handleSubmit=()=>{
        if(username==''){
            props.popupOpenClose("true", `${t("gha.enter_username")}`);
            return;
        }
        resetMyPassword();
    }
 

    useEffect(() => {

        scrollToTop();


    }, []);


    return (
<>
{
    (currentPage==1)
    ?
    <>
        <header class="inner-pages w-footer subpages">
            <a class="button-back" onClick={props.handleGoBack}></a>
            <div class="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${props.logo}`} />
                </div>
            </div>
        </header>
        <section class="widgets">
            <div class="widget-header">
                <div class="widget-header-img">
                    <img src={require("./assests/forgetPassword.png")} />
                </div>
                <div class="widget-header-title"> {t("gha.forgot_password_heading")}</div>
                <div class="widget-header-subtitle">{t("gha.forgot_password_subtitle")}</div>
            </div>
            <div id="GHALogin" class="widgets sign-up">
                <div class="row sign-up-form">



                    <div class="form-row">
                        <label>{t("gha.email_address")}<span style={{ color: 'red' }}>*</span></label>
                        <input type="text" placeholder="Enter email" autoComplete='email' value={username} onChange={(e) => setUsername(e.target.value)} />
                    </div>

                </div>
            </div>
            <div class="form-controls">


                {showLoader ? <button disabled class="secondary w-100"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('gha.resetting')}</button> :
                    <button class="secondary w-100" onClick={handleSubmit}>{t("gha.reset_password")}</button>
                }

            </div>
        </section>

    </>
    :
    <>
        <header class="inner-pages w-footer subpages">
            <a class="button-back" onClick={props.handleGoBack}></a>
            <div class="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${props.logo}`} />
                </div>
            </div>
        </header>
        <section class="widgets">
            <div class="widget-header">
                <div class="widget-header-img">
                                    <img src={require("./assests/forgetPassword.png")} />
                </div>
                <div class="widget-header-title">{t("gha.check_inbox_heading")}</div>
            </div>
            <div id="GHALogin" class="widgets sign-up">
                <div class="row">
                    <p class="align-center">{t("gha.check_inbox_subheading")}
                        </p>
                    <div class="form-controls">
                        <button class="primary w-100 margin-bottom-1" onClick={props.handleGoBack}>{t("gha.okay")}</button>
                    </div>
                </div>
            </div>
        </section>

    </>

}
</>
        
    );
};

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
    };
};

export default connect(mapStateToProps, { popupOpenClose ,closeOrderPopUp, sendAnalytics })(
    withTranslation("translations")(Gha_ResetPassword)
);
